'use strict';

import $ from 'jquery';
import config from '../../js/config';
import utilities from '../../js/utilities';
import User from '../../services/CartUserService';
import * as globalisation from '../../utilities/globalisation';
import ModalView from '../../js/components/ModalView';
import template from '../BackorderForm/templates/BackorderForm-modal.hbs';


export default class ProductQuantityFormModal extends ModalView {
  initialize(options) {
    super.initialize(options);
    this.basicQuantityValidation = false;
    this.render();
    this.addBuyingOptionQuantityValidatorMethods();
  }

  initializeElements() {
    this.$form = this.$('.ProductQuantityForm');
    this.$errors = this.$('.ProductQuantityForm-modalIcon-errors');
    this.$quantity = this.$('#ProductQuantityForm-quantity');
    this.$firstName = this.$('#ProductQuantityForm-firstName');
    this.$lastName = this.$('#ProductQuantityForm-lastName');
    this.$email = this.$('#ProductQuantityForm-email');
    this.$lastElement = this.$('#ProductQuantityForm-modal-submit');
    this.$firstElement = this.$('#ProductQuantityForm-modal-close');
  }

  /**
   * Add the validation method for the quantity.
   */
  addBuyingOptionQuantityValidatorMethods() {
    $.validator.addMethod('buyingOptionQuantity', this.validateBuyingOption.bind(this));
  }

  /**
   * Validate the quantity for a buying option.
   *
   * @param {number} quantity
   * @param {HTMLElement} element
   * @param {{buyingOption: Backbone.Model}} params
   * @returns {boolean}
   */
  validateBuyingOption(quoteQuantity, element, params) {
    quoteQuantity = utilities.parseQuantity(quoteQuantity);
    let model = params.buyingOption.toJSON();

    if (model && model.groupedBuyingOption) {
      model = model.groupedBuyingOption;
    }

    let error;

    if (!utilities.isInteger(quoteQuantity)) {
      error = 'modalInvalidQuantityError';
    } else if (!this.basicQuantityValidation && quoteQuantity < model.orderMinimumQuantity) {
      // Verify the min quantity
      error = 'modalMinQuantityNotReachedError';
    } else if (!this.basicQuantityValidation && quoteQuantity % model.orderIncrement !== 0) {
      // Verify the increment
      error = 'modalQuantityNotInIncrementsOfError';
    } else if (!quoteQuantity) {
      // Verify quantity entered
      error = 'modalNoQuantityError';
    }

    if (!error) {
      params.validatedBuyingOptions = [this.generateValidatedBuyingOption(quoteQuantity, model.sourcePartId, model.sourceCode)];
      return true;
    }

    // Set the error message that will be used
    params.error = globalisation.pluraliseAndTranslate('shoppingCart', error, model);

    return false;
  }

  generateValidatedBuyingOption(quantity, sourcePartId, sourceCode) {
    return { quantity, sourcePartId, sourceCode };
  }

  _getValidatorConfig() {
    let firstNameTranslation = globalisation.pluraliseAndTranslate('forms', 'firstName');
    let lastNameTranslation = globalisation.pluraliseAndTranslate('forms', 'lastName');
    let emailTranslation = globalisation.pluraliseAndTranslate('forms', 'email');

    return {
      errorClass: config.classes.isInvalid,
      validClass: config.classes.isValid,
      errorElement: 'strong',
      wrapper: 'li',
      errorLabelContainer: this.$errors,
      ignoreTitle: true,
      messages: {
        firstName: globalisation.pluraliseAndTranslate('formValidation', 'requiredFieldName', { fieldName: firstNameTranslation }),
        lastName: globalisation.pluraliseAndTranslate('formValidation', 'requiredFieldName', { fieldName: lastNameTranslation }),
        email: {
          required: globalisation.pluraliseAndTranslate('formValidation', 'requiredFieldName', { fieldName: emailTranslation }),
          email: globalisation.pluraliseAndTranslate('formValidation', 'email')
        },
        quantity: {
          required: globalisation.pluraliseAndTranslate('shoppingCart', 'invalidQuantityError'),
          buyingOptionQuantity: params => params.error
        },
        quoteQuantity: {
          required: globalisation.pluraliseAndTranslate('shoppingCart', 'invalidQuantityError'),
          buyingOptionQuantity: params => params.error
        }
      }
    }
  }

  createValidator() {
    this.validator = this.$form.validate(this._getValidatorConfig());
    this.addQuantityValidator();
  }

  addQuantityValidator() {
    // Add the correct type of quantity validation
    this.$quantity.rules('add', { buyingOptionQuantity: this.modalData });
  }

  prePopulateUserDetails() {
    if (User.isUserLoggedIn() && User.userInfo && User.userInfo.fullName !== 'Guest') {
      this.$('#ProductQuantityForm-firstName').val(User.userInfo.firstName);
      this.$('#ProductQuantityForm-lastName').val(User.userInfo.lastName);
      this.$('#ProductQuantityForm-email').val(User.userInfo.email);
    }
  }

  /**
   * When the modal is opened.
   */
  onOpen() {
    this.initializeElements();
    this.prePopulateUserDetails();
    this.createValidator();
    this.$('.ProductQuantityForm-modal').attr('aria-modal',true);
    this.$('.ProductQuantityForm-modal').parent().removeAttr('tabindex');
    this.$quantity.focus();
    this.$firstElement.on('keydown',(e)=>{
      if (e.key === 'Tab' && e.shiftKey) {
        e.preventDefault();
        this.$lastElement.focus();
      }
    });
    this.$lastElement.on('keydown', (e)=>{
      if (e.key === 'Tab' && !e.shiftKey) {
        e.preventDefault();
        this.$firstElement.focus();
      }
    });
  }

  onClose() {
    this.$('.ProductQuantityForm-modal').removeAttr('aria-modal');
    $(this.qouteButton).focus();
  }

  render() {
    if (this.modalData && this.modalData.buyingOption) {
      let model = this.modalData.buyingOption.toJSON();
      this.qouteButton = '#qoute-' + model.partId;
      if (model && model.groupedBuyingOption) {
        model = model.groupedBuyingOption;
      }
      this.$el.html(template(model));
    }
  }

  /**
   * When the form is submitted - i.e. the confirm action of the modal.
   */
  onConfirm() {
    // Already doing something
    if (this.$form.hasClass(config.classes.loadingClass)) {
      return;
    }

    this.validator.form();

    // If we are valid
    if (!this.validator.numberOfInvalids()) {
      let firstName = this.$firstName.val();
      let lastName = this.$lastName.val();
      let emailAddress = this.$email.val();

      this.onSuccess(firstName, lastName, emailAddress, this.modalData.validatedBuyingOptions);
    }
    if (this.validator.invalid.quoteQuantity !== undefined)
    {
      $('#ProductQuantityForm-quantity')[0].focus();
    }
    else if (this.validator.invalid.email !== undefined)
    {
      $('#ProductQuantityForm-email')[0].focus();
    }
  }

  /**
   * Success action of the submitted form
   *
   * @param {string} firstName
   * @param {string} lastName
   * @param {string} emailAddress
   * @param {Object[]} products
   * @param {string} products[].sourceCode
   * @param {string} products[].sourcePartId
   * @param {number} products[].quantity
   */
  onSuccess(firstName, lastName, emailAddress, products) { // eslint-disable-line
    this.close('confirmation');
  }
}



// WEBPACK FOOTER //
// ./assets/components/ProductQuantityFormModal/ProductQuantityFormModal.js